/* eslint-disable react/jsx-indent */
import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import PersonHoldingGroundedFlagLightTheme from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PersonHoldingGroundedFlag';
import PersonWithPlusCircleLightTheme from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PersonWithPlusCircle';
import ThreeConnectedNodesLightTheme from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ThreeConnectedNodes';
// styles
import {
  ColStyled,
  RowStyled,
  SectionContainerStyled,
} from './styles';

export default () => {
  const linkText ='Find out more';

  return (
    <SectionContainerStyled
      id='long-term-care-planning-product-callout-grouping-2'
      backgroundVariant='lightA'
      moduleName='product-callout-grouping-module'
      moduleVariation='A'>
      <Row align='center'>
        <Col xsmall={10}>
          <Typography
            align='center'
            component='h2'
            nextElement='graphic'>
            Learn more about long&#45;term <WidowBlock>care options</WidowBlock>
          </Typography>
        </Col>
      </Row>
      <RowStyled align='left'>
        <ColStyled
          medium={6}
          large={4}>
          <ProductCard
            icon={PersonHoldingGroundedFlagLightTheme}
            backgroundVariant='lightB'
            cardId='product-callout-long-term-care-standalone'
            cardHeading='Standalone'
            cardText={
              <>
                This traditional long&#45;term care option is typically more affordable than others and it can be purchased independently of other insurance policies.
              </>
            }
            linkText={linkText}
            linkUrl='/long-term-care-planning/search-by-state/'
            ariaLabel='Find out more about long term care planning'
          />
        </ColStyled>
        <ColStyled
          medium={6}
          large={4}>
          <ProductCard
            icon={ThreeConnectedNodesLightTheme}
            backgroundVariant='lightB'
            cardId='product-callout-long-term-care-hybrid'
            cardHeading='Hybrid'
            cardText={
              <>
                By combining whole life insurance with a long&#45;term care rider, you&#39;ll have long&#45;term care coverage if you need it, but if you don&#39;t, your beneficiaries get the death benefit.
              </>
            }
            linkText={linkText}
            linkUrl='/long-term-care-planning/hybrid-long-term-care-insurance/'
            ariaLabel='Find out more about hybrid long term care planning'
          />
        </ColStyled>
        <ColStyled
          medium={6}
          large={4}>
          <ProductCard
            icon={PersonWithPlusCircleLightTheme}
            backgroundVariant='lightB'
            cardId='product-callout-long-term-care-accelerated-payout'
            cardHeading='Life insurance with an accelerated payout'
            cardText={
              <>
                Help pay for long&#45;term care expenses by tapping into the death benefit of a life insurance policy, but doing so will decrease the death benefit and surrender value.<sup>3</sup>
              </>
            }
            linkText={linkText}
            linkUrl='/life-insurance/whole-life-insurance/'
            ariaLabel='Find out more about whole life insurance'
          />
        </ColStyled>
      </RowStyled>
    </SectionContainerStyled>
  );
};
